/**
 * ChartsWidget — Wrapper widget pour DashboardCharts (Batch #14.78).
 *
 * Affiche les 3 graphiques (Revenus vs Dépenses, Répartition dépenses, État paiements)
 * dans le système de widgets configurables du dashboard.
 *
 * Recommandé : largeur 2 (full-width) pour ne pas tronquer les graphiques.
 */
import { useEffect, useState } from "react";
import { api } from "@/api";
import { DashboardCharts } from "../DashboardCharts";

export default function ChartsWidget() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const year = new Date().getFullYear();

  useEffect(() => {
    api.get(`/dashboard/summary?civil_year=${year}`)
      .then((r) => setSummary(r.data || {}))
      .catch(() => setSummary(null))
      .finally(() => setLoading(false));
  }, [year]);

  if (loading) {
    return (
      <div className="text-center text-slate-400 text-xs py-8" data-testid="widget-charts-loading">
        Chargement des graphiques…
      </div>
    );
  }
  if (!summary) {
    return (
      <div className="text-center text-slate-400 text-xs py-8" data-testid="widget-charts-empty">
        Aucune donnée disponible.
      </div>
    );
  }
  return (
    <div data-testid="widget-charts">
      <DashboardCharts summary={summary} year={year} />
    </div>
  );
}
